import { useBreakpoint } from '@hooks/useBreakpoint';
import type { NativeStackNavigationOptions } from '@react-navigation/native-stack';
import { useMemo } from 'react';
import { useTheme } from 'tamagui';

// Provides the shared Stack screen options used by the tab layouts' headers.
export function useSharedStackScreenOptions(): NativeStackNavigationOptions {
  const { isSmallScreen } = useBreakpoint();
  const theme = useTheme();
  const backgroundColor = theme.background?.val;
  const tintColor = theme.color?.val;

  return useMemo(
    () => ({
      headerShown: isSmallScreen,
      headerStyle: {
        backgroundColor,
      },
      headerTintColor: tintColor,
      headerTitle: '',
      headerTransparent: false,
      headerBlurEffect: 'none',
      contentStyle: {
        backgroundColor,
      },
    }),
    [backgroundColor, isSmallScreen, tintColor],
  );
}
